export default __webpack_public_path__ + "assets/favicons/upc-favicon.ico";